import React from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import {connect} from 'react-redux';
import Button from 'react-bootstrap/lib/Button';
import {MODALVISIBILITY} from '../../../actions/constantsActions';
import SendFriendTask from '../../../requests/tasks/SendFriendTask';
import ValidateCaptchaCardTask from '../../../requests/tasks/ValidateCaptchaCardTask';
import RequestManager from '../../../requests/RequestManager';
import FormValidations from '../../../data/FormValidations';
import * as actions from '../../../actions/response';
import InlineInputClaro from '../../forms/InlineInputClaro';
import InlineTextAreaClaro from '../../forms/InlineTextAreaClaro';
import InlineCaptchaClaro from '../../forms/InlineCaptchaClaro';
import { converter } from '../../../helpers/converter';


class ModalEmail extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      form: {
        name: "",
        from: "",
        email: "",
        message: "",
        captcha: ""
      },
      errors: {}
    };
    
    this.state.captchaSrc = this.getCaptcha();
    this.setFormState = this.setFormState.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.isValidForm = this.isValidForm.bind(this);
  }

  getCaptcha() {
    return 'https://www.clarovideo.com/scripts/captcha/captcha.php?sid=' + Math.floor((Math.random() * 6) + 1);
  }

  closeModal() {
    this.props.closeModal('Email');
  }

  isValidForm() {
    var formValid = true;
    this.state.errors = {};

    Object.assign(this.state.errors,
      new FormValidations(this.state.form.from, 'from')
        .validateMinLongitude(1, converter.convertApaUnicode(this.props.translations, 'social_recomendar_error_from'))
        .getErrors());

    Object.assign(this.state.errors,
      new FormValidations(this.state.form.name, 'name')
        .validateMinLongitude(1, converter.convertApaUnicode(this.props.translations, 'social_recomendar_error_to'))
        .getErrors());

    Object.assign(this.state.errors,
      new FormValidations(this.state.form.email, 'email')
        .validateEmailFormat(converter.convertApaUnicode(this.props.translations, 'social_recomendar_error_email'))
        .getErrors());

    Object.assign(this.state.errors,
      new FormValidations(this.state.form.message, 'message')
        .validateMinLongitude(1, converter.convertApaUnicode(this.props.translations, ''))
        .getErrors());

    Object.assign(this.state.errors,
      new FormValidations(this.state.form.captcha, 'captcha')
        .validateMinLongitude(1, converter.convertApaUnicode(this.props.translations, 'social_recomendar_error_captcha'))
        .getErrors());

    Object.assign(this.state.errors,
      new FormValidations(this.state.form.captcha, 'captcha')
        .validateMaxLongitude(4, converter.convertApaUnicode(this.props.translations, 'social_recomendar_error_captcha'))
        .getErrors());

    if (Object.keys(this.state.errors).length !== 0) {
      this.setState({captchaSrc: this.getCaptcha()});
      formValid = false;
    }

    this.setState({errors: this.state.errors});
    return formValid;
  }
  
  sendToFriend() {
    if (!this.isValidForm()) {
      return;
    }

    const capParams = {
      node: this.props.nodeId,
      captcha: this.state.form.captcha
    };

    const reqCaptcha = new ValidateCaptchaCardTask(this.props.config, this.props.region, capParams)
    RequestManager.addRequest(reqCaptcha)
      .then((data) => {

        Object.assign(this.state.form, {group_id: this.props.groupId});
        const params = {
          from: this.state.form.from,
          name: this.state.form.name,
          email: this.state.form.email,
          message: this.state.form.message,
          captcha: this.state.form.captcha,
          url_recomendar: window.location.href,
          url_descripcion:'',
          enviar_recomendacion: true,
          objeto_recomendar:'ficha',
          url_titulo: this.props.urlTitulo,
          src_imagen: this.props.srcImagen,
          node: this.props.nodeId
        };

        const request = new SendFriendTask(this.props.config, this.props.user, params);
        RequestManager.addRequest(request)
        
        const modal = {
          modalType: 'SuccessSimple',
          props: {
            message: converter.convertApaUnicode(this.props.translations, 'social_recomendar_envio_exito_text') + ' ' + this.state.form.name
          }
        };

        this.props.showModal(modal);
     
      })
      .catch((e) => {
        console.log(e);
      });    
  }

  setFormState(event) {
    this.state.form[event.target.name] = event.target.value;
    return this.setState({form: this.state.form});
  }

  render() {
    const closeButtonClass = 'close close-modal';
    const buttonContinueClass = "btn btn-primary btn-lg btn-block";
 
    return (
      <Modal show={true}>
        <Modal.Header>
          <Button className={closeButtonClass} onClick={this.closeModal}>x</Button>
          <h2 className='modal-title'>{converter.convertApaUnicode(this.props.translations, 'social_recomendar_titulo_label')}</h2>
        </Modal.Header>
        <Modal.Body>
          <form className="form-paso1">
            <InlineInputClaro
              idElement="from"
              type="text"
              labelText={converter.convertApaUnicode(this.props.translations, 'social_recomendar_from_label')}
              placeholderText={converter.convertApaUnicode(this.props.translations, 'social_recomendar_from_label')}
              inputClassName="col-lg-8 col-md-8 col-sm-12 col-xs-12"
              labelClassName="col-sm-4 control-label hidden-sm hidden-xs"
              onChange={this.setFormState}
              value={this.state.form.from}
              error={this.state.errors.from}
            />

            <InlineInputClaro
              idElement="name"
              type="text"
              labelText={converter.convertApaUnicode(this.props.translations, 'social_recomendar_to_label')}
              placeholderText={converter.convertApaUnicode(this.props.translations, 'social_recomendar_to_label')}
              inputClassName="col-lg-8 col-md-8 col-sm-12 col-xs-12"
              labelClassName="col-sm-4 control-label hidden-sm hidden-xs"
              onChange={this.setFormState}
              value={this.state.form.name}
              error={this.state.errors.name}
            />

            <InlineInputClaro
              idElement="email"
              type="text"
              labelText={converter.convertApaUnicode(this.props.translations, 'social_recomendar_email_label')}
              placeholderText={converter.convertApaUnicode(this.props.translations, 'social_recomendar_email_label')}
              inputClassName="col-lg-8 col-md-8 col-sm-12 col-xs-12"
              labelClassName="col-sm-4 control-label hidden-sm hidden-xs"
              onChange={this.setFormState}
              value={this.state.form.email}
              error={this.state.errors.email}
            />

            <InlineTextAreaClaro
              idElement="message"
              type="text"
              labelText={converter.convertApaUnicode(this.props.translations, 'social_recomendar_msg_label')}
              placeholderText={converter.convertApaUnicode(this.props.translations, 'social_recomendar_msg_label')}
              inputClassName="col-lg-8 col-md-8 col-sm-12 col-xs-12"
              labelClassName="col-sm-4 control-label hidden-sm hidden-xs"
              onChange={this.setFormState}
              value={this.state.form.message}
              error={this.state.errors.message}/>

            <InlineCaptchaClaro
              idElement="captcha"
              type="text"
              labelText={converter.convertApaUnicode(this.props.translations, 'social_recomendar_codigo_seguridad_label')}
              placeholderText={converter.convertApaUnicode(this.props.translations, 'social_recomendar_codigo_seguridad_label')}
              inputClassName="col-lg-8 col-md-8 col-sm-12 col-xs-12"
              captchaClassName="col-sm-4 control-label"
              captchaSrc ={ this.state.captchaSrc }
              onChange={this.setFormState}
              value={this.state.form.captcha}
              error={this.state.errors.captcha}
            />
            
          </form>
        </Modal.Body>
        <Modal.Footer>
          <div className="col-lg-6 col-md-6 col-xs-12 col-sm-12" style={{'float': 'right', 'marginTop': '20px'}}>
            <div className="form-group">
              <input
                type="submit"
                onClick={this.sendToFriend.bind(this)}
                className={buttonContinueClass}
                value={converter.convertApaUnicode(this.props.translations, 'social_recomendar_aceptar')}/>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    )
  }
}

const mapStateToProps = state => {
  return {
    modal: state.modal,
    config: state.config,
    user: state.user,
    translations: state.translations,
  };
};

const mapDispatchToProps = (dispatch) => ({
  closeModal(modalType) {
    dispatch(actions.removeModal(modalType));
  },
  showModal(modal) {
    dispatch(actions.showModal(modal));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalEmail);
